document.addEventListener("DOMContentLoaded", function () {

    const $priceDom = $('#sp_price1');
    const $cPriceDom = $('#sp_price2');
    const $offPriceDom = $('.price-group .sp-p span');
    const $numDom = $('#calcNumber');

    const productData = window.product || [];

    /** 获取当前选中的变量 */
    function getCur() {
        const opts = {
            option1: $('#sp-opt-group1 div.active').attr('data-val'),
            option2: $('#sp-opt-group2 div.active').attr('data-val'),
            option3: $('#sp-opt-group3 div.active').attr('data-val')
        };

        return productData.find(item => {
            return (!opts.option1 || item.option1 == opts.option1) &&
                (!opts.option2 || item.option2 == opts.option2) &&
                (!opts.option3 || item.option3 == opts.option3);
        });
    }

    /** 更新价格显示 */
    function changePrice() {
        const curVariant = getCur();
        if (!curVariant) return;

        const num = parseInt($numDom.val()) || 1;

        // 识别当前页面使用的小数点符号
        const currentText = $priceDom.text().trim();
        const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/);

        const decimalSeparator = decimalMatch ? decimalMatch[1] : '.';
        const decimalLength = decimalMatch ? decimalMatch[2].length : 0;

        // 格式化输出
        const formatValue = (cents) => {
            let val = (cents * num / 100).toFixed(decimalLength);
            if (decimalSeparator === ',') {
                val = val.replace('.', ',');
            }
            return val;
        };

        const price = formatValue(curVariant.price);
        const compare = formatValue(curVariant.compare_at_price);

        // 计算折扣
        let offPercent = 0;
        if (curVariant.compare_at_price > curVariant.price) {
            offPercent = 100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100);
        }

        const priceRegex = /\d+(?:[.,]\d+)*/;
        const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g;

        const updateHTML = ($el, regex, value) => {
            if ($el && $el.length) {
                const text = $el[0].textContent.trim();
                const newHtml = text.replace(regex, value);
                if ($el.html() !== newHtml) {
                    $el.html(newHtml);
                }
            }
        };

        updateHTML($priceDom, priceRegex, price);
        updateHTML($cPriceDom, priceRegex, compare);
        updateHTML($offPriceDom, offRegex, offPercent);
    }

    // 绑定选项点击事件
    $(document).on('click', '.sp-option', function () {
        setTimeout(changePrice, 10);
    });

    $('.sp_buy_now').click(function () {

        let num = $numDom.val();
        let id = getCur().id;
        window.location.href = '/cart/' + id + ':' + num;

    });
    // 倒计时
    function getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    let endTimeG;

    function cutDownTime() {
        let nowTime = new Date();
        let endTime = new Date(endTimeG);

        let leftTime = endTime.getTime() - nowTime.getTime();
        if (leftTime < 0) {
            setupNewCountdown();
            leftTime = 0;
        }
        let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
            leftM = Math.floor((leftTime / (1000 * 60)) % 60),
            leftS = Math.floor((leftTime / 1000) % 60);
        leftH = leftH >= 10 ? leftH : "0" + leftH;
        leftM = leftM >= 10 ? leftM : "0" + leftM;
        leftS = leftS >= 10 ? leftS : "0" + leftS;

        return {
            hour: leftH,
            minute: leftM,
            second: leftS,
        };
    }
    function setupNewCountdown() {
        const randomHour = getRandomNum(1, 9);
        const currentTime = new Date();
        endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
    }
    let intervalId;

    function getCutDownTime() {
        setupNewCountdown();
        if (intervalId) clearInterval(intervalId);
        intervalId = setInterval(function () {
            let cutDownTimeText = cutDownTime();
            $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
            $(".sp_top_cut_down .sp_left_view .sp_minute").html(
                cutDownTimeText.minute
            );
            $(".sp_top_cut_down .sp_left_view .sp_second").html(
                cutDownTimeText.second
            );
        }, 1000);
    }

    getCutDownTime();

    new WOW().init();

    jQuery(".sp-scroll").slide({
        mainCell: ".nav-imgs",
        autoPlay: true,
        effect: "leftMarquee",
        interTime: 12,
        vis: 1,
        scroll: 1,
    });

    new Swiper('.mySwiper', {
        slidesPerView: 'auto',
        spaceBetween: 35,
        loop: true, //循环滚动
        freeMode: true,
        speed: 6500, //匀速时间
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: true,
        },
        allowTouchMove: false,
    })

    new Swiper(".sp-swiper1", {
        speed: 2000,
        autoplay: true,
        autoplay: {
            delay: 1,
            disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: true,
    });

    new Swiper(".sp-swiper2", {
        autoplay: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        pagination: {
            el: ".sp-pagination2",
            clickable: true,
        },
    });

    new Swiper(".sp-swiper-fade", {
        spaceBetween: 10,
        effect: "fade",
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
            delay: 2000,
        },
        speed: 2000,
    });

    new Swiper(".sp-swiper-fade1", {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 10,
        loop: true,
        on: {
            slideChange: function (e) {
                e.slides.find(".sp-text").each(function () {
                    this.style.animation = "none";
                });
                const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
                if (spText) {
                    spText.style.animation = "none";

                    spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
                }
            },
        },
    });

    new Swiper(".sp-swiper0", {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 10,
        loop: true,
    });

    function mainRender() {
        $(function () {
            $("#root").css("zoom", "normal");
            if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
            } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
            }

            window.addEventListener(
                "resize",
                (function () {
                    var timer;
                    return function () {
                        if (timer) clearTimeout(timer);
                        timer = setTimeout(function () {
                            $("#root").css("zoom", "normal");
                            if (document.body.clientWidth <= 1060) {
                                let scale = document.body.clientWidth / 1080;
                                $("#root").css("zoom", scale);
                            } else {
                                const scale = document.body.clientWidth / 1920;
                                $("#root").css("zoom", scale);
                            }
                            updateMainImage();
                        }, 100);
                    };
                })()
            );
        });

        function lazyLoadImages() {
            // 懒加载
            const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
            const config = {
                rootMargin: "0px 0px 1300px 0px",
                threshold: 0,
            };

            const lazyLoadObserver = new IntersectionObserver(function (
                entries,
                observer
            ) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        // 当图片进入视口时
                        const image = entry.target;
                        const dataSrc = image.getAttribute("data-src");
                        if (dataSrc) {
                            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
                        }
                        lazyLoadObserver.unobserve(image); // 停止观察该图片
                    }
                });
            },
                config);

            images.forEach(function (image) {
                lazyLoadObserver.observe(image); // 开始观察每个图片
            });
        }

        function preloadImages(imageArray) {
            // 预加载
            // 检查数组数据结构
            if (Array.isArray(imageArray[0])) {
                // 处理二维数组
                imageArray.forEach((subArray) => {
                    subArray.forEach((url) => {
                        const img = new Image();
                        img.src = url;
                    });
                });
            } else {
                // 处理一维数组
                imageArray.forEach((url) => {
                    const img = new Image();
                    img.src = url;
                });
            }
        }

        lazyLoadImages();

        let imgList = [
            "https://cdn.shopify.com/s/files/1/0711/9736/0412/files/20260324-p1.png",
            "https://cdn.shopify.com/s/files/1/0711/9736/0412/files/20260324-p2.png",
            "https://cdn.shopify.com/s/files/1/0711/9736/0412/files/20260324-p3.png",
            "https://cdn.shopify.com/s/files/1/0670/1141/2200/files/1_1_5ba17ee6-9517-42d4-bdde-6ea080e2409b.png?v=1780395053",
            "https://cdn.shopify.com/s/files/1/0670/1141/2200/files/2_1_1.png?v=1780395053",
            "https://cdn.shopify.com/s/files/1/0670/1141/2200/files/3_2_1.png?v=1780395053s",
            "https://cdn.shopify.com/s/files/1/0711/9736/0412/files/20260417__img_1.jpg?v=1776390529",
            "https://cdn.shopify.com/s/files/1/0711/9736/0412/files/20260417__img_3.jpg?v=1776390529",
            "https://cdn.shopify.com/s/files/1/0711/9736/0412/files/20260417__img_5.jpg?v=1776390529",
            "https://cdn.shopify.com/s/files/1/0711/9736/0412/files/20260324-p4.png",
            "https://cdn.shopify.com/s/files/1/0711/9736/0412/files/20260324-p5.png",
            "https://cdn.shopify.com/s/files/1/0711/9736/0412/files/20260324-p6.png",
        ];
        // for (let i = 1; i <= 6; i++) {
        //   imgList.push(`https://cdn.shopify.com/s/files/1/0711/9736/0412/files/20260324-p${i}.png`);
        // }

        // 预加载所有图片
        preloadImages(imgList);

        // 更新主图显示
        function updateMainImage() {
            const typeIndex = $("#sp-opt-group1 .sp-option.active").index();
            const careIndex = $("#sp-opt-group2 .sp-option.active").index() || 0;
            const imageIndex = typeIndex + careIndex * 3;
            // const imageIndex = typeIndex;

            if (typeIndex == 0 || careIndex == 1) {
                $(".product-part .sp-img-wrap .sp-free-img").hide();
            } else {
                $(".product-part .sp-img-wrap .sp-free-img").show();
            }

            // 与 #root zoom 一致：≤1060 为移动布局；left 移动为按 923/710 比例对齐后的独立数值，top 移动 306px / PC 252px（同 index.css）
            var isMobileLayout = document.body.clientWidth <= 1060;
            var freeLeftPc = { "1,0": 543, "2,0": 614, "1,1": 521, "2,1": 538 };
            var freeLeftMobile = { "1,0": 706, "2,0": 798, "1,1": 678, "2,1": 700 };
            var key = typeIndex + "," + 0;
            if (freeLeftPc[key] !== undefined) {
                $(".product-part .sp-img-wrap .sp-free-img").css({
                    left: (isMobileLayout ? freeLeftMobile[key] : freeLeftPc[key]) + "px",
                    top: isMobileLayout ? "332px" : "252px",
                });
            }

            // 更新图片
            $(".sp-img-p").attr("src", imgList[imageIndex]);
        }

        $(".sp-option").click(function () {
            $(this).siblings().removeClass("active");
            $(this).addClass("active");

            updateMainImage();
        });

        // 初始化图片
        updateMainImage();

        // IOS字体多了间距的处理
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        var isAndroid = /android/i.test(userAgent);
        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent);

        if (!isAndroid && !isIOS && !isPC) {
            $(".sp_system").css("letter-spacing", "-4px");
        }
    }

    mainRender();

    // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工作
    function handleShoppingLinkClick(event) {
        const link = event.target.closest('a[href="#shopping"]');
        if (!link) return;

        event.preventDefault();

        const targetElement = document.getElementById("shopping");
        if (targetElement) {
            const offsetTop = targetElement.offsetTop;
            let sptop = document.body.clientWidth <= 1080 ? 230 : 230;
            let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
            const scrollTop = offsetTop * zoomValue - sptop * zoomValue;

            window.scrollTo({
                top: scrollTop,
                behavior: "smooth",
            });

            setTimeout(() => {
                if (window.pageYOffset === 0 || Math.abs(window.pageYOffset - scrollTop) > 100) {
                    $('html, body').animate({
                        scrollTop: scrollTop
                    }, 800);
                }
            }, 100);
        }
    }

    // 使用事件委托在document上监听所有点击
    document.addEventListener('click', handleShoppingLinkClick);

    let sp_price1 = 9.99;
    let sp_price2 = 19.89;

    function calcTotal(price, num) {
        let result = Number(price) * Number(num);
        return result.toFixed(2);
    }
    $(".sp-reduce").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) - 1;
        if (num > 0) {
            input.value = num;
        }
        changePrice()
    });
    $(".sp-add").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) + 1;
        input.value = num;
        changePrice()
    });

    // 标题文本渐出
    const graduallyList = document.getElementsByClassName("gradually");
    for (let gradually of graduallyList) {
        const spans = gradually.querySelectorAll("span, div");
        const paragraph = gradually.querySelector(".sp-sub-title");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // 给每个 span/div 和 i 动画
                        spans.forEach((span, index) => {
                            span.style.animation = `swift-up-fade 0.5s ease forwards`;
                            span.style.animationDelay = `${index * 0.1}s`;

                            const i = span.querySelector("i");
                            if (i) {
                                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                                i.style.animationDelay = `${index * 0.1}s`;
                            }
                        });

                        // 段落
                        const totalDelay = spans.length * 0.1 + 0.3;
                        if (paragraph) {
                            paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`;
                            paragraph.style.animationDelay = `${totalDelay}s`;
                        }

                        observer.unobserve(gradually);
                    }
                });
            },
            {
                threshold: 0.3,
            }
        );
        observer.observe(gradually);
    }

    // 菜单
    $(".sp-menu-btn").click(function (e) {
        $(".sp-menu-mask").show();
    });

    $(".sp-menu-mask").click(function (e) {
        $(".sp-menu-mask").hide();
    });

    function getZoomValue() {
        let zoom = $("div#root").css("zoom");
        return parseFloat(zoom) || 1;
    }

    function handleScroll() {
        // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        // let zoomValue = getZoomValue();
        // let headerHeight = $(".header:visible").height() * zoomValue;

        // if (scrollTop > headerHeight) {
        //   $(".sp-pc .sp-header-top").addClass("sp-fixed");
        // } else {
        //   $(".sp-pc .sp-header-top").removeClass("sp-fixed");
        // }
    }

    // 初始检查
    handleScroll();

    // 监听多种滚动事件
    window.addEventListener('scroll', handleScroll, true);
    document.addEventListener('scroll', handleScroll, true);

    $(function () {
        // 判断是否为移动端
        function isMobile() {
            return document.body.clientWidth <= 1060;
        }

        // 购物车加购动效
        $(".cart-btn").click(function () {
            $(this).children("img").addClass("on");
            if (isMobile()) {
                $(".sp-mobile .sp-cart .num").show();
                $(".sp-mobile .sp-cart").addClass("on");
                setTimeout(function () {
                    $(".sp-mobile .sp-cart").removeClass("on");
                }, 500);
            } else {
                $(".sp-pc .sp-header-top .sp-cart .num").show();
                $(".sp-pc .sp-header-top .sp-cart").addClass("on");
                setTimeout(function () {
                    $(".sp-pc .sp-header-top .sp-cart").removeClass("on");
                }, 500);
            }
            setTimeout(function () {
                $(".cart-btn").children("img").removeClass("on");
            }, 500);
        });

        let initNum = 0;

        $(".product-part .cart-btn").click(function () {
            var data = {
                id: getCur().id,
                quantity: $('#calcNumber').val(),
            };
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: data,
                success: function () {
                    $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
                        // $("#cardNum").html(result.item_count);
                        $(".cardNum").each(function () {
                            $(this).html(result.item_count);
                            $(this).removeClass("sp-gray");

                        });
                    });
                },
                dataType: "json",
            });
            var imgs = $(".sp-img-p.active");

            imgs.each(function () {
                var $img = $(this);
                var flyer = $img[0].cloneNode(true);
                flyer.classList.add("sp_clone");

                $(".product-part").append(flyer);
                $(flyer).css({
                    width: $img[0].width,
                    height: $img[0].height,
                    background: "#e7e9ef",
                    position: "fixed",
                    top: $img[0].offsetTop,
                    left: $img.offset().left,
                    "z-index": 99,
                });

                let finish, targetTop, targetLeft;

                if (isMobile()) {
                    // 移动端：飞向底部固定按钮中的购物车
                    finish = $(".sp-btn-style2.sp-mobile .sp-cart");
                    if (finish.length > 0) {
                        targetTop = $(".sp-btn-style2")[0].offsetTop;
                        targetLeft = $(".sp-btn-style2 .sp-cart")[0].offsetLeft;
                    } else {
                        targetTop = 0;
                        targetLeft = 0;
                    }
                } else {
                    // PC端：飞向header中的购物车
                    finish = $(".sp-pc .sp-cart");
                    if (finish.length > 0) {
                        targetTop = finish[0].offsetTop;
                        targetLeft = finish[0].offsetLeft;
                    } else {
                        targetTop = 0;
                        targetLeft = 0;
                    }
                }

                $(flyer).animate(
                    {
                        top: targetTop,
                        left: targetLeft,
                        width: 50,
                        height: 50,
                        opacity: 0.4,
                    },
                    500,
                    "linear",
                    function () {
                        $(this).animate(
                            {
                                width: 0,
                                height: 0,
                                opacity: 0,
                            },
                            0,
                            function () {
                                $(this).detach();
                            }
                        );
                    }
                );
            });
        });
    });

    // 问答
    $(".q-row").click(function () {
        $(this).parent().toggleClass("sp-show");
    });

    // 文本渐出动画
    const graduallyList2 = document.getElementsByClassName("sp-fade-box");
    for (let gradually2 of graduallyList2) {
        const paragraph2 = gradually2.querySelectorAll(".sp-ani");

        const observerAni = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        paragraph2.forEach((span, index) => {
                            span.style.animation = `sp-fade-in 1s ease forwards`;
                            span.style.animationDelay = `${index * 0.5 + 0.5}s`;
                        });

                        observerAni.unobserve(gradually2);
                    }
                });
            },
            {
                threshold: 0.3,
            }
        );
        observerAni.observe(gradually2);
    }
    // 文本渐出动画
    const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
    for (let gradually3 of graduallyList3) {
        const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

        const observerAni = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        paragraph3.forEach((span, index) => {
                            span.style.animation = `sp-fade-left 1s ease forwards`;
                            span.style.animationDelay = `${index * 0.3 + 1}s`;
                        });

                        observerAni.unobserve(gradually3);
                    }
                });
            },
            {
                threshold: 0.3,
            }
        );
        observerAni.observe(gradually3);
    }

    function updateSpPart6TapHint() {
        $(".sp-part6").each(function () {
            var $p = $(this);
            var $img1 = $p.find(".sp-item.sp-image1 img");
            var $hint = $p.children(".sp-ani-box").children(".sp-text");
            if (!$hint.length) return;
            if (!$img1.length || !$img1.hasClass("active")) {
                $hint.css("display", "none");
            } else {
                $hint.css("display", "");
            }
        });
    }

    function initSpDropFly() {
        var fly = document.getElementById("sp-drop-fly");
        if (!fly) return;
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            document.querySelectorAll(".sp-part4").forEach(function (el) {
                el.classList.add("sp-drop-arrived");
            });
            return;
        }

        document.querySelectorAll(".sp-part4").forEach(function (p4) {
            bindSpDropFlySection(p4, fly);
        });
    }

    function bindSpDropFlySection(p4, fly) {
        var fired = false;
        var obs = null;
        var $p4 = $(p4);

        function finishFly() {
            if (fly._spDropRaf != null) {
                cancelAnimationFrame(fly._spDropRaf);
                fly._spDropRaf = null;
            }
            var flyScale = fly.querySelector(".sp-drop-fly-scale");
            var flyImg = fly.querySelector(".sp-drop-fly-scale img");
            fly.style.transition = "opacity 0.28s ease";
            fly.style.opacity = "0";
            p4.classList.add("sp-drop-arrived");
            setTimeout(function () {
                fly.classList.remove("is-active");
                fly.style.transition = "";
                fly.style.opacity = "0";
                fly.style.transform = "";
                fly.style.left = "";
                fly.style.top = "";
                if (flyScale) {
                    flyScale.style.transform = "";
                    flyScale.style.transition = "";
                }
                if (flyImg) {
                    flyImg.style.width = "";
                    flyImg.style.maxWidth = "";
                }
            }, 300);
        }

        function play() {
            if (fired) return;
            if (!$p4.is(":visible")) return;

            var isPcBlock = p4.classList.contains("sp-pc");
            var p3 = isPcBlock
                ? document.querySelector(".sp-part3.sp-pc")
                : document.querySelector(".sp-part3.sp-mobile");
            if (!p3 || !$(p3).is(":visible")) return;

            var srcIcon = p3.querySelector(".sp-icon");
            var targetImg = null;
            var ch = p4.children;
            for (var ci = 0; ci < ch.length; ci++) {
                if (
                    ch[ci].tagName === "IMG" &&
                    ch[ci].classList &&
                    ch[ci].classList.contains("sp-image")
                ) {
                    targetImg = ch[ci];
                    break;
                }
            }
            var flyScale = fly.querySelector(".sp-drop-fly-scale");
            var flyImg = fly.querySelector(".sp-drop-fly-scale img");
            if (!srcIcon || !targetImg || !flyImg || !flyScale) return;

            fired = true;
            if (obs) {
                obs.disconnect();
                obs = null;
            }

            function syncFlyFromTarget() {
                var ss = targetImg.getAttribute("srcset");
                if (ss) {
                    flyImg.setAttribute("srcset", ss);
                } else {
                    flyImg.removeAttribute("srcset");
                }
                flyImg.src = targetImg.currentSrc || targetImg.src;
            }

            function measureAndAnimate() {
                if (fly._spDropRaf != null) {
                    cancelAnimationFrame(fly._spDropRaf);
                    fly._spDropRaf = null;
                }

                var r0 = srcIcon.getBoundingClientRect();
                var r1 = targetImg.getBoundingClientRect();
                var startX = r0.left + r0.width / 2;
                var startY = r0.top + r0.height / 2;
                var x1 = r1.left + r1.width / 2;
                var y1 = r1.top + r1.height / 2;

                if (r1.width < 2 || r1.height < 2) {
                    x1 = startX;
                    y1 = startY + Math.max(r0.height * 4, 160);
                }

                var endW = Math.max(r1.width, 8);
                var startScale = Math.max(r0.width, 4) / endW;

                flyImg.style.width = endW + "px";
                flyImg.style.height = "auto";
                flyImg.style.maxWidth = "none";
                fly.classList.add("is-active");
                fly.style.transition = "none";
                flyScale.style.transition = "none";
                fly.style.transform = "translate(-50%, -50%)";
                fly.style.left = startX + "px";
                fly.style.top = startY + "px";
                flyScale.style.transform = "scale(" + startScale + ")";
                fly.style.opacity = "0";

                srcIcon.classList.add("sp-drop-moved");

                var t0 = performance.now();
                var duration = 880;
                var opacityIn = 320;

                function easeOutCubic(t) {
                    return 1 - Math.pow(1 - t, 3);
                }

                function tick(now) {
                    var elapsed = (now || performance.now()) - t0;
                    var p = duration <= 0 ? 1 : Math.min(1, elapsed / duration);
                    var e = easeOutCubic(p);

                    var r1c = targetImg.getBoundingClientRect();
                    var cx1 = r1c.left + r1c.width / 2;
                    var cy1 = r1c.top + r1c.height / 2;
                    if (r1c.width < 2 || r1c.height < 2) {
                        cx1 = startX;
                        cy1 = startY + Math.max(r0.height * 4, 160);
                    }

                    var x = startX + (cx1 - startX) * e;
                    var y = startY + (cy1 - startY) * e;
                    var sc = startScale + (1 - startScale) * e;

                    fly.style.left = x + "px";
                    fly.style.top = y + "px";
                    fly.style.opacity = String(Math.min(1, elapsed / opacityIn));
                    flyScale.style.transform = "scale(" + sc + ")";

                    if (p < 1) {
                        fly._spDropRaf = requestAnimationFrame(tick);
                    } else {
                        fly._spDropRaf = null;
                        fly.style.left = cx1 + "px";
                        fly.style.top = cy1 + "px";
                        flyScale.style.transform = "scale(1)";
                        fly.style.opacity = "1";
                        finishFly();
                    }
                }

                fly._spDropRaf = requestAnimationFrame(tick);
            }

            function startWhenReady() {
                function go() {
                    requestAnimationFrame(function () {
                        requestAnimationFrame(measureAndAnimate);
                    });
                }
                var needT = !(targetImg.complete && targetImg.naturalWidth > 0);
                var needF = !(flyImg.complete && flyImg.naturalWidth > 0);
                var wait = (needT ? 1 : 0) + (needF ? 1 : 0);
                if (wait === 0) {
                    go();
                    return;
                }
                function done() {
                    wait--;
                    if (wait === 0) go();
                }
                if (needT) targetImg.addEventListener("load", done);
                if (needF) flyImg.addEventListener("load", done);
            }

            syncFlyFromTarget();
            startWhenReady();
        }

        function tryPlayIfInView() {
            if (fired) return;
            if (!$p4.is(":visible")) return;
            var rect = p4.getBoundingClientRect();
            if (rect.top < window.innerHeight * 0.88 && rect.bottom > 40) {
                play();
            }
        }

        obs = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting || fired) return;
                    play();
                });
            },
            { threshold: 0.14, rootMargin: "0px 0px -10% 0px" }
        );
        obs.observe(p4);

        requestAnimationFrame(function () {
            requestAnimationFrame(tryPlayIfInView);
        });
        setTimeout(tryPlayIfInView, 400);
        window.addEventListener("load", tryPlayIfInView);
    }

    function initSpPart4PcSplitReveal() {
        var text = document.querySelector(".sp-part4.sp-pc .sp-text");
        if (!text) return;
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            text.classList.add("sp-split-revealed");
            return;
        }

        var done = false;
        var obs = null;

        function reveal() {
            if (done) return;
            done = true;
            if (obs) obs.disconnect();
            text.classList.add("sp-split-revealed");
        }

        obs = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting || done) return;
                    reveal();
                });
            },
            { threshold: 0.14, rootMargin: "0px 0px -10% 0px" }
        );
        obs.observe(text);

        function tryRevealIfInView() {
            if (done) return;
            var r = text.getBoundingClientRect();
            if (r.top < window.innerHeight * 0.9 && r.bottom > 48) {
                reveal();
            }
        }

        requestAnimationFrame(function () {
            requestAnimationFrame(tryRevealIfInView);
        });
        setTimeout(tryRevealIfInView, 400);
        window.addEventListener("load", tryRevealIfInView);
    }

    initSpDropFly();
    initSpPart4PcSplitReveal();

    $(document).on("click", ".sp-part6 .sp-item", function () {
        var $item = $(this);
        var $inner = $item.children(".sp-flip-inner");
        if (!$inner.length) return;
        var $img = $inner.children("img");
        var $box = $inner.children(".sp-box");
        if (!$img.length || !$box.length) return;
        if ($img.hasClass("active")) {
            $img.removeClass("active");
            $box.addClass("active");
            $item.addClass("is-flipped");
        } else {
            $box.removeClass("active");
            $img.addClass("active");
            $item.removeClass("is-flipped");
        }
        updateSpPart6TapHint();
    });

    updateSpPart6TapHint();
});
